import { useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Button, CircularProgress, FormControl, Grid, Typography } from '@mui/material';
import apiService from '../../../utlis/apiService';
import DownloadIcon from '@mui/icons-material/Download';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';
import { apiUrl } from '../../../config';

export default function SalesAgentReport() {
    const [data,setData] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [filterData, setFilterData] = useState({
        fromDate: '',
        toDate: '',
    });

    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        getData()
    }, [filterData]);

    const getData = async () => {
        try {
            setLoading(true);
            const response = await apiService.get('/report/sales-agent', {
                params: {
                    ...filterData,
                },
            });
            setData(response?.data?.report);
            setTotalResults(response?.data?.totalResults);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (name, value) => {
        setFilterData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const exportReport = async () => {
        try {
            const response = await apiService.get('/export/report/sales-agent', {
                params: {
                    ...filterData,
                },
            });

            if(response?.data?.status === 'success') {
                
                window.open(`${apiUrl}${response?.data?.path}`, '_blank');
            }
        }
        catch (error) {
            console.error(error);
        }
    }

  return (
    <div style={{ height: '70vh', width: '100%' }}>
        <Typography variant="h4" gutterBottom>
            SALES AGENT REPORT
        </Typography>
        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 2}}>
            <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                    <FormControl className='gap-2 mb-8' fullWidth size='small'>
                        <MobileDatePicker
                            value={filterData.dateFrom ? dayjs(filterData.dateFrom) : null}
                            onChange={(date) => handleChange('dateFrom', date)}
                            sx={{ marginTop: 2 }}
                            format="DD/MM/YYYY"
                            label="Date From"
                            slotProps={{
                                actionBar: {
                                    actions: ['clear', 'cancel', 'accept'],
                                },
                                textField: { size: 'small' }
                            }}
                        />
                    </FormControl>
                </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                    <FormControl className='gap-2 mb-8' fullWidth size='small'>
                        <MobileDatePicker
                            value={filterData.dateTo ? dayjs(filterData.dateTo) : null}
                            onChange={(date) => handleChange('dateTo', date)}
                            sx={{ marginTop: 2 }}
                            format="DD/MM/YYYY"
                            label="Date To"
                            slotProps={{
                                actionBar: {
                                    actions: ['clear', 'cancel', 'accept'],
                                },
                                textField: { size: 'small' }
                            }}
                        />
                    </FormControl>
                </LocalizationProvider>
            </Grid>
        </Grid>
        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 3 }}>
            <Grid item xs={4}>
            </Grid>
            <Grid item xs={8}>
                <Button variant="outlined" size='small' sx={{ float: 'right' }} title="Export" onClick={exportReport}><DownloadIcon /></Button>
            </Grid>
        </Grid>

        {loading ? (
            <div style={{ textAlign: 'center' }}>
                <CircularProgress style={{ margin: 'auto' }} />
            </div>
        ) : (
            <DataGridPro
                getRowId={(row) => row._id}
                rows={data}
                disableDensitySelector
                columns={[
                    { field: 'email', headerName: 'Email', flex: 1 },
                    { field: 'revenue', headerName: 'Revenue', flex: 1 },
                ]}
                rowCount={totalResults}
            />
        )}
    </div>
  );
}
